var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooksAllocationHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52763 22.2793C2.68394 22.2793 2 22.9632 2 23.8069V23.8069C2 24.6506 2.68394 25.3346 3.52763 25.3346H4.03001C4.76611 25.3346 5.36284 25.9313 5.36284 26.6674V26.6674C5.36284 27.4035 5.95958 28.0002 6.69568 28.0002H7.10578C7.84189 28.0002 8.43862 27.4035 8.43862 26.6674V26.6674C8.43862 25.9313 9.03535 25.3346 9.77145 25.3346H20.2291C20.9652 25.3346 21.5619 25.9313 21.5619 26.6674V26.6674C21.5619 27.4035 22.1586 28.0002 22.8948 28.0002H23.3049C24.041 28.0002 24.6377 27.4035 24.6377 26.6674V26.6674C24.6377 25.9313 25.2344 25.3346 25.9705 25.3346H26.4729C27.3166 25.3346 28.0005 24.6506 28.0005 23.8069V23.8069C28.0005 22.9632 27.3166 22.2793 26.4729 22.2793H3.52763Z",
    fill: "#F7FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8447 7.26979L24.6997 6.77766L24.3511 4.07098C24.2896 3.64037 23.9 3.3328 23.4694 3.39431L21.1728 3.66088C20.7422 3.7224 20.4346 4.11199 20.4961 4.5426L20.8447 7.26979Z",
    fill: "#F7FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5244 20.5567C22.5859 20.9873 22.9755 21.2949 23.4061 21.2334L25.7027 20.9463C26.1333 20.8848 26.4409 20.4952 26.3793 20.0646L26.0308 17.3579L22.1758 17.85L22.5244 20.5567Z",
    fill: "#F7FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8379 7.79748L20.9727 8.2876L22.0586 16.8521L25.9238 16.362L24.8379 7.79748Z",
    fill: "#F7FAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1391 2.7997C14.1391 2.36909 13.7905 2 13.3394 2H10.5302C10.0996 2 9.73047 2.34859 9.73047 2.7997V5.52689H14.1391V2.7997Z",
    fill: "#F7FAFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5292 21.2544H13.3589C13.7895 21.2544 14.1586 20.9058 14.1586 20.4547V17.7275H9.75V20.4547C9.75 20.9058 10.0986 21.2544 10.5292 21.2544Z",
    fill: "#F7FAFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1586 6.55273H9.75V16.7233H14.1586V6.55273Z",
    fill: "#F7FAFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2651 4.3163C19.2651 3.88569 18.9165 3.5166 18.4654 3.5166H16.1688C15.7382 3.5166 15.3691 3.86519 15.3691 4.3163V7.04349H19.2651V4.3163Z",
    fill: "#F7FAFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1687 21.2544H18.4858C18.9164 21.2544 19.2855 20.9058 19.2855 20.4547V17.7275H15.3895V20.4547C15.369 20.9058 15.7176 21.2544 16.1687 21.2544Z",
    fill: "#F7FAFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2651 8.08984H15.3691V16.7225H19.2651V8.08984Z",
    fill: "#F7FAFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52085 2.7997C8.52085 2.36909 8.17226 2 7.72115 2H4.39931C3.9687 2 3.59961 2.34859 3.59961 2.7997V5.52689H8.52085V2.7997Z",
    fill: "#F7FAFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 20.4752C3.59961 20.9058 3.9482 21.2749 4.39931 21.2749H7.72115C8.15175 21.2749 8.52085 20.9263 8.52085 20.4752V17.7275H3.59961V20.4752Z",
    fill: "#F7FAFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52085 6.55273H3.59961V16.7233H8.52085V6.55273Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksAllocationHeader);
export default __webpack_public_path__ + "static/media/BooksAllocationHeader.56b62dc82e2d09326e502a2179903159.svg";
export { ForwardRef as ReactComponent };